import React, { useEffect } from 'react';
import {
  BorderBottomOutlined,
  BorderTopOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
} from '@ant-design/icons';
import { Button, Divider, notification, Space } from 'antd';
//import type { NotificationPlacement } from 'antd/es/notification/interface';
import { Row, Col, Container } from 'react-bootstrap';
import serverDown from '../../../assets/images/AccessDenied.png';

const App= ({title, message}:any) => {    
  const [api, contextHolder] = notification.useNotification();
  
  notification.config({
    placement: 'top',
    bottom: 50,
    duration: 5,
    rtl: true,
  }); 

  useEffect(()=>{
    notification.info({ message: `${title}`,description:`${message}`, style:{backgroundColor: '#2980b963'}});
  },[])

  return (
    <>
      {contextHolder}
      <div className="account-pages mt-5 mb-5">      
            <Container>
                <Row className="justify-content-center">
                    
                    <Col xl={4} lg={5} xs={8}>
                        <div className="text-center">
                            <div>
                                <img src={serverDown} alt="" className="img-fluid" />
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} className="text-center">
                        <h3 className="mt-3">عدم دسترسی</h3>
                        <p className="text-muted mb-4">
                            شما مجوز مشاهده و استفاده از این صفحه را ندارید
                            <br /> جهت خرید یا ارتقاء دسترسی با مدیر سیستم در ارتباط باشید
                        </p>
                        {/* <Link to="/" className="btn btn-lg btn-primary">
                            Take me back to Home
                        </Link> */}
                    </Col>
                </Row>
            </Container>
        </div>
      
    </>
  );
};

export default App;